var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaterFireDamageRestoration = function SvgWaterFireDamageRestoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    viewBox: "0 0 128 128"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b-water-fire-damage{stroke-miterlimit:10;fill:none;stroke:#0071bc;stroke-width:3px}.c-water-fire-damage{fill:none;stroke:#0071bc;stroke-width:3px;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.4 53.64-9.34 9.72h9.44v21.52c0 9.97 8.08 18.05 18.05 18.05h31.66c9.97 0 18.05-8.08 18.05-18.05V63.73s8.47.36 9.19-.36L63.62 17.99 50.83 32.51",
    className: "c-water-fire-damage"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.48 65.25c-.71 30.09-25.68 53.92-55.78 53.21-30.09-.71-53.92-25.68-53.21-55.78.71-30.09 25.68-53.92 55.78-53.21 13.17.31 25.13 5.26 34.37 13.26",
    className: "c-water-fire-damage"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.74 16.06v15h-15s15.97-15 15-15",
    className: "c-water-fire-damage"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.87 78.06s5.08-.54 7.62 1.63 6.53 3.27 9.07 1.09 7.08-4.54 11.8-.91 7.8 1.45 9.62.54 5.63-3.81 9.62-.73c3.99 3.09 7.99 3.09 11.25.73s5.08-2.54 7.99-2.18M29.87 83.59s5.08-.54 7.62 1.63 6.53 3.27 9.07 1.09 7.08-4.54 11.8-.91 7.8 1.45 9.62.54 5.63-3.81 9.62-.73 7.99 3.09 11.25.73 5.08-2.54 7.99-2.18",
    className: "b-water-fire-damage"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 38.65,
    cy: 42.63,
    r: 16.14,
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 39.74c-.34 7.17 5.82 13 13 13 5.38 0 9.54-2.86 11.29-7.32 1.16-2.96.94-6.29-.4-9.17-.88-1.88-2.31-3.84-4.59-4.6 0 0 .65 4.9-1.96 7.52 0 0-3.6-9.15 0-17 0 0-6.87 3.6-9.81 12.75l-.65-7.85s-6.54 5.72-6.87 12.67Z",
    className: "c-water-fire-damage"
  })));
};
export default SvgWaterFireDamageRestoration;